import classnames from 'classnames'
import * as React from 'react'

import {stringifyId} from '../../../../../types'
import {toGroups} from '../../../../../utils/array'
import {useBuildsClassName} from '../../../../common/Builds/Builds'
import Grid from '../../../../common/Grid/Grid'
import Visible from '../../../../common/Visible/Visible'
import {sortSameChildren} from '../../AgentsPages.utils'
import type {AgentsTreeAgentNode} from '../../AgentsSidebar/AgentsSidebar.types'

import AgentRow from './AgentRow/AgentRow'

import styles from './AgentsGroup.css'

const GROUP_SIZE = 10

type GroupProps = {
  childNodes: ReadonlyArray<AgentsTreeAgentNode>
  sortingType: string | undefined
  canRemoveAgents?: boolean
}

function AgentsGroup({
  childNodes = [],
  sortingType,
  canRemoveAgents,
}: GroupProps): React.ReactElement {
  const className = classnames(useBuildsClassName(), styles.container)
  return (
    <Visible>
      {isVisible => (
        <div className={styles.group}>
          {toGroups(
            GROUP_SIZE,
            isVisible ? sortSameChildren(childNodes, sortingType) : childNodes,
          ).map((group, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <Grid key={i} className={className}>
              {group.map(agentNode => (
                <AgentRow
                  key={stringifyId(agentNode.id)}
                  className={styles.agent}
                  {...agentNode}
                  removable={canRemoveAgents}
                />
              ))}
            </Grid>
          ))}
        </div>
      )}
    </Visible>
  )
}

export default AgentsGroup
